import {
  Box,
  Dialog,
  DialogProps,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { Button } from "components/button";
import React from "react";
import { convertStringToSentenceCase } from "utilz/helpers";

interface ModalProps extends DialogProps {
  title?: string;
  tagline?: string | React.ReactNode;
  isPrimaryButtonDisabled?: boolean;
  isSecondaryButtonDisabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  paperStyles?: React.CSSProperties;
  type?: "primary" | "error";
  isLoading?: boolean;
  keepTitleOriginalCasing?: boolean;
}

export const DeleteConfirmationModal = ({
  title = "Delete confirmation",
  tagline = "Are you sure you want to delete?",
  keepTitleOriginalCasing = false,
  open,
  paperStyles,
  onClose,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonText = "Delete",
  secondaryButtonText = "Cancel",
  type = "error",
  isLoading = false,
  ...rest
}: ModalProps) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      // maxWidth={false}
      PaperProps={{
        style: {
          borderRadius: "20px",
          padding: "32px",
          width: "360px",
          maxWidth: "100%",
          height: "auto",
          ...paperStyles,
        },
      }}
      onClose={(event: React.SyntheticEvent, reason: string) => {
        if (reason === "backdropClick") {
          event.stopPropagation();
          onClose && onClose(event, reason);
        }
      }}
      {...rest}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h5">
          {typeof title === "string" && !keepTitleOriginalCasing
            ? convertStringToSentenceCase(title)
            : title}
        </Typography>
        <Typography
          sx={{ mt: "10px" }}
          variant="body-large"
          color={theme.palette.lightBg.low}
        >
          {tagline}
        </Typography>
        <Stack direction="row" mt="24px" gap="16px" justifyContent="flex-end">
          <Button
            disabled={isLoading}
            variant="secondary"
            onClick={onSecondaryButtonClick}
          >
            {secondaryButtonText}
          </Button>
          <Button
            loading={isLoading}
            variant="primary"
            onClick={onPrimaryButtonClick}
            sx={{
              ...(type === "error"
                ? {
                    bgcolor: theme.palette.error.main,
                    "&:hover": { backgroundColor: "#A9050E" },
                  }
                : {}),
            }}
          >
            {primaryButtonText}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};
